module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "inner-banner"
  }, [_vm._c('div', {
    staticClass: "copy",
    class: _vm.subText ? 'with-sub' : ''
  }, [_vm._c('h1', {
    staticClass: "serif"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subText) ? _vm._c('p', [_vm._v("\n      " + _vm._s(_vm.subText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "bg"
  }, [_vm._c('picture', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": _vm.imageUrl + '_500.jpg',
      "media": "(max-width: 500px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": _vm.imageUrl + '_800.jpg',
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": _vm.imageUrl + '_1200.jpg',
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": _vm.imageUrl + '_1600.jpg',
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": _vm.imageUrl + '_2000.jpg',
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": _vm.imageUrl + '_1600.jpg',
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0db491b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/shared/controls/InnerBanner.vue
// module id = 620
// module chunks = 1